export enum PopoverMode {
  LIGHT = "light",
  DARK = "dark",
}
